import { useLabelContactsQuery } from '../gpanel-contacts-queries';
import GpanelContactsGrid from './gpanel-contacts/gpanel-contacts-grid/gpanel-contacts-grid';
import TooltipWithPermission from '../shared/components/tooltip-with-permission';
import { GPanelContactsPermissions } from '../../../../utils/roles/client-roles';
import { useState } from 'react';
import { useGpanelContactsPermissions } from '../shared/hooks/use-gpanel-contacts-permissions';
import { useLabelFromGroups } from '../shared/hooks/use-label-from-groups';
import GPanelContactsDeleteDialog from './gpanel-contacts/gpanel-contacts-delete-dialog.tsx';
import GPanelContactsManageLabelDialog from './gpanel-contacts/gpanel-contacts-manage-label-dialog.tsx';
import { useUserSettings } from '../../../../utils/use-user-settings.tsx';
import { GPanelContactsPagesConfig } from '../shared/pages-config.ts';
import { useNavigate } from 'react-router-dom';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button.tsx';

export default function GpanelContactsLabelContactsGrid() {
  const [trashOpen, setTrashOpen] = useState(false);
  const [addContactsToLabelOpen, setAddContactsToLabelOpen] = useState(false);
  const { PERMISSIONS } = useGpanelContactsPermissions();
  const label = useLabelFromGroups();
  const query = useLabelContactsQuery(label?.id);
  const { viewType } = useUserSettings();

  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const handleViewLogs = () => {
    navigate(`./${GPanelContactsPagesConfig.LabelsLogs.link}`);
  };

  return (
    <GpanelContactsGrid
      labelId={label?.id}
      withHeaderActions
      query={query}
      title={label?.name || ''}
      syncRunning={label?.syncRunning || false}
      gridKey={viewType.gpanelContactsGridStates?.activeGridState}
      onRefresh={() => {
        query.refetch();
      }}
      contactsToolbarActions={(selection) => (
        <>
          {/* Standalone View Logs Button */}
          <TooltipWithPermission
            title="View Logs"
            hasPermission={PERMISSIONS.viewLogs}
            permissionName={GPanelContactsPermissions.ViewLogs.name}
            renderElement={(hasPermission) => (
              <SharedIconButton
                variant="list"
                disabled={!hasPermission}
                onClick={handleViewLogs}
                disableTooltip
              />
            )}
          />
          <TooltipWithPermission
            hasPermission={PERMISSIONS.modifyGpanelContactLabelMembers}
            permissionName={
              GPanelContactsPermissions.ModifyGpanelContactLabelMembers.name
            }
            renderElement={(hasPermission) => (
              <SharedIconButton
                variant="label"
                disabled={!hasPermission || !selection?.length}
                onClick={(e) => {
                  setMenuAnchorEl(e.currentTarget);
                  setAddContactsToLabelOpen(true);
                }}
                disableTooltip
              />
            )}
          />
          {addContactsToLabelOpen && selection?.length && (
            <GPanelContactsManageLabelDialog
              handleClose={() => {
                setAddContactsToLabelOpen(false);
                setMenuAnchorEl(null);
              }}
              anchorEl={menuAnchorEl}
              contactIds={selection}
              contacts={query.data}
            />
          )}

          <TooltipWithPermission
            title="Trash Contacts"
            hasPermission={PERMISSIONS.trashContact}
            permissionName={GPanelContactsPermissions.TrashContact.name}
            renderElement={(hasPermission) => (
              <SharedIconButton
                variant="delete"
                disabled={!hasPermission || !selection?.length}
                onClick={() => setTrashOpen(true)}
                tooltipLabel="Delete"
                disableTooltip
              />
            )}
          />
          {trashOpen && selection?.length && (
            <GPanelContactsDeleteDialog
              contactIds={selection}
              handleClose={() => setTrashOpen(false)}
            />
          )}
        </>
      )}
    />
  );
}
